import { Group, ActionIcon, rem, Image } from '@mantine/core';
import logo from '../../assets/logo.png'; // Replace with your logo path

export function FooterCentered() {
  return (
    <div 
      className="footer" 
      style={{ 
      position: 'fixed',
      bottom: 0,
      left: 0,
      right: 0,
      width: '100%',
      padding: '0.2rem', 
      borderTop: '1px solid black',
      backgroundColor: 'white',
      zIndex: 110, // Increased zIndex
      pointerEvents: 'none', // Prevent mouse events on container
      boxSizing: 'border-box' // Ensure padding/border included in width
}}
    >
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', textAlign: 'center' }}>
        <Image src={logo} height={30} width={30} />
        <Group style={{ 
            flex: 1, 
            justifyContent: 'center', 
            pointerEvents: 'auto', 
            fontSize: '0.9rem', 
          }}>
            Navriti Technologies © All rights reserved
        </Group>
        
      </div>
    </div>
  );
}